import AppSmartBanner from './AppSmartBanner';

export default AppSmartBanner;
